import styled from "styled-components";
import Informacoes from "./Informacoes";
import ContainerFormularios from "./ContainerFormularios";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useModal } from "../../contexts/ModalContext";
import Overlay from "../../Componentes/Overlay";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";
import ModalBeneficios from "./ModalBeneficios";
import { VerifyPermission } from "../../Funcoes/VerifyPermission";
import { AuthContext } from "../../Auth/AuthProvider";
import ModalAddFolga from "./ModalAddFolga";

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    gap: 10px;
`

const ContentContainer = () => {

    const { user } = useContext( AuthContext );

    const { matricula } = useParams()

    const { isModalOpen, closeModal, openModal } = useModal();

    const [loading, setLoading] = useState(true);

    const [colabInfo, setColabInfo] = useState([]);

    const fetchColab = async () => {

        try {

            const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Colaborador/GetInfo/index.php?matricula=${matricula}`)
            console.log(data);

            setColabInfo(data);

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        fetchColab();

    }, [])

    const openBenefts = () => {

        closeModal();
        openModal('tabelaBeneficios')

    }

    const openFolgaCampo = () => {
        closeModal();
        openModal('addNewFolga');
    }

    return (
        <>
            <Container>
                <Informacoes data={colabInfo.protheus} />
                <ContainerFormularios
                    data={colabInfo.custom}
                    fetchData={fetchColab}
                    folgasCampo={colabInfo.folgas}
                />
            </Container>
            {isModalOpen('sidebarColaborador') && (
                <Overlay state={true} changeContent={closeModal} >
                    <SideMenu>
                        {VerifyPermission( user, { modulo: "rh", submodulo: "colaborador", funcao: "view_benefits" }) && (
                            <SideMenuBtn
                                button="BENEFÍCIOS"
                                clickFunc={openBenefts}
                            />
                        )}
                        <SideMenuBtn
                            button="FOLGA DE CAMPO"
                            clickFunc={openFolgaCampo}
                        />
                    </SideMenu>
                </Overlay>
            )}
            {(isModalOpen('tabelaBeneficios') && VerifyPermission( user, { modulo: "rh", submodulo: "colaborador", funcao: "view_benefits" })) && (
                <ModalBeneficios />
            )}
            {isModalOpen('addNewFolga') && (
                <ModalAddFolga
                    info={ colabInfo.protheus }
                    fetchData={fetchColab}
                />
            )}
        </>
    )
}

export default ContentContainer;